import { Component, OnInit } from "@angular/core";
import { NgxXml2jsonService } from "ngx-xml2json";
import { CfdiApi } from "src/shared/sdk";
import moment from "moment";

@Component({
  selector: "app-llistado-notas-credito",
  templateUrl: "./llistado-notas-credito.component.html",
  styleUrls: ["./llistado-notas-credito.component.scss"],
})
export class LlistadoNotasCreditoComponent implements OnInit {
  loading: boolean;
  cfdis = <any>[];
  displayedColumns: string[] = [
    "fechaTimbrado",
    "folio",
    "uuid",
    "relacion",
    "receptor",
    "total",
  ];
  desde: any;
  hasta: any;
  busca: any;
  constructor(
    private cfdiApi: CfdiApi,
    private ngxXml2jsonService: NgxXml2jsonService
  ) {}

  ngOnInit() {
    this.obtenNotasCredito();
  }

  async obtenNotasCredito() {
    this.loading = true;
    let where = {
      "data.tipoComprobante": "E-Egreso",
      estatus: {
        neq: "Cancelado",
      },
    };

    if (this.desde || this.hasta) {
      if (typeof where["fechaTimbrado"] === "undefined") {
        where["fechaTimbrado"] = {};
      }
    }
    if (this.desde) {
      where["fechaTimbrado"].gte = moment(this.desde).toISOString();
    }
    if (this.hasta) {
      where["fechaTimbrado"].lte = moment(this.hasta).toISOString();
    }
    if (this.busca) {
      where["or"] = [
        {
          "data.folio": {
            like: this.busca,
          },
          "data.uuid": {
            like: this.busca,
          },
        },
      ];
    }
    console.log(where);
    this.cfdis = await this.cfdiApi
      .find({
        where: where,
        limit: 100,
        order: "fechaTimbrado DESC",
      })
      .toPromise();
    for (let i = 0; i < this.cfdis.length; i++) {
      const cfdi = this.cfdis[i];
      const parser = new DOMParser();
      const xml = parser.parseFromString(cfdi.data.cfdi, "text/xml");
      this.cfdis[i].xml = this.ngxXml2jsonService.xmlToJson(xml);
    }
    this.loading = false;
    console.log(this.cfdis);
  }
}
